<div class="middle-box text-center loginscreen animated fadeInDown">
  <div>
      <div class="mt-5">

          <h1 class="logo-name"><img src="https://cdn11.bigcommerce.com/s-wgbbk70ij7/images/stencil/original/ceres-tag_2020_1597704590__74325.original.png"/></h1>

      </div>
      <h3 class="mt-5 mb-5 h3">Onboarding Ceres Tag Customer</h3>
      <div *ngIf="azureAuthService.isLoggedIn" class="mt-5">
        <p>You are already authenticated, you can complete the onboarding process by clicking the button below</p>
        <form class="m-t">
          <button (click)="completeOnboarding()" type="submit" class="btn btn-white block full-width m-b">Complete Linking</button>
      </form>
      </div>
      <div *ngIf="!azureAuthService.isLoggedIn" class="mt-5">      
        <p >You will need to log in to complete the onboarding process for linking to Ceres Tag. You will redirect shortly if not click the login button.</p>
        <form>
            <button type="submit" class="btn btn-white block full-width m-b mt-5">Login</button>
        </form>
        <div class="alert alert-success alert-dismissable fade show p-3" *ngIf="errorMessage">
          <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
          <h4 class="alert-heading">ERROR!</h4>
          <p>{{errorMessage}}</p>
        </div>
      </div>  
      <p class="m-t mt-5"> <small>Indicium Dynamics Pty Ltd. Copyright 2022</small> </p>
  </div>
</div>